// src/pages/Reports/IssuanceReporting/IssuanceTicketLookup/index.tsx
// README.md mục 7 — trang "Tra cứu vé / dải vé": RPT-015 (tra cứu 1 vé), RPT-016 (tra cứu 1 dải).
// Đặt tên "IssuanceTicketLookup" (khác src/pages/TicketLookup — tra cứu kết quả vé qua QR, public)
// để tránh nhầm lẫn tên thư mục.

import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Container, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import BreadCrumb from 'Components/Common/BreadCrumb';
import { useBrandingTitle } from 'hooks';
import SingleTicketLookupTab from './SingleTicketLookupTab';
import RangeLookupTab from './RangeLookupTab';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

type TabKey = 'single' | 'range';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'single', label: st('tra_cuu_1_ve_label') },
  { key: 'range', label: st('tra_cuu_dai_ve_label') },
];

const IssuanceTicketLookupPage: React.FC = () => {
  useBrandingTitle(st('tra_cuu_ve_text'));
  const [activeTab, setActiveTab] = useState<TabKey>('single');

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={st('tra_cuu_ve_text')} pageTitle={st('bao_cao_phat_hanh_text')} />

        <Card>
          <CardHeader className="card-header border-0">
            <Nav tabs className="nav-tabs-custom card-header-tabs flex-wrap">
              {TABS.map((tab) => (
                <NavItem key={tab.key}>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === tab.key })}
                    onClick={(e) => { e.preventDefault(); setActiveTab(tab.key); }}
                  >
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </CardHeader>
          <CardBody>
            {activeTab === 'single' && <SingleTicketLookupTab />}
            {activeTab === 'range' && <RangeLookupTab />}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default IssuanceTicketLookupPage;
